export const FAQ_ITEMS = [
    {
        question: 'Сколько стоит страховка?',
        answer: 'Стоимость страховки 700 рублей на одного туриста. Вы можете застраховать как одного пассажира, так и всех, кто летит с вами. Чем больше застрахованных, тем больше не только стоимость страхования, но и компенсация за задержку или отмену рейса.',
    },
    {
        question: 'Какие перелеты можно застраховать?',
        answer: 'Застраховать можно задержку или последующую отмену рейса из любого аэропорта мира любой авиакомпании, включая зарубежные. Страховкой покрываются все рейсы вашего путешествия — как туда, так и обратно.',
    },
    {
        question: 'Как узнать размер выплаты?',
        answer: 'Если ваш рейс будет задержан более чем на 3 часа, вам необходимо обратиться в страховую компанию по ссылке в полисе. Страховая компания рассчитает длительность задержки и отправит SMS с информацией о сумме компенсации и порядке её получения.',
    },
    {
        question: 'Как оформить страховку на несколько полетов?',
        answer: 'Полис покрывает не более пяти перелётов. Если у вас запланировано больше перелётов, необходимо оформить дополнительную страховку.',
    },
    {
        question: 'У меня в полисе ошибка! Что делать?',
        answer: 'Ничего страшного. Черехапа всё уладит. Просто свяжитесь с нами. Мы пришлём вам исправленный полис в течение рабочего дня.',
    },
    {
        question: 'Что делать, если письмо с полисом не пришло на электронную почту?',
        answer: 'Проверьте папку «Спам». Если письма нет — напишите нам на почту или в мессенджеры, продублируем полис. Чаще всего причина в опечатке при вводе email.',
    },
];
